// GET https://api.swiftaid.co.uk/donor/v1-dev/me/donations
// Default Bob Fossil fixture, personas use buildFinancialYearsFromSpecs directly.

import { buildFinancialYearsFromSpecs } from '../personas/donation-fixtures'

const YEAR_SPECS = [
  { period: '2026-2027', count: 10 },
  { period: '2025-2026', count: 20, bigGiftPence: 450000 },
  { period: '2024-2025', count: 7, bigGiftPence: 380000 },
  { period: '2023-2024', count: 14, bigGiftPence: 325000 },
  { period: '2022-2023', count: 20, bigGiftPence: 500000 },
  { period: '2021-2022', count: 9, bigGiftPence: 350000 },
  { period: '2020-2021', count: 0 },
  { period: '2019-2020', count: 12, bigGiftPence: 420000 },
]

export default { financialYears: buildFinancialYearsFromSpecs(YEAR_SPECS) }
